<template>
  <div class="d-flex flex-column h-100">
    <div
      v-if="!conversation"
      class="d-flex flex-grow-1 align-items-center justify-content-center text-muted"
    >
      {{ $t('whatsapp.select-a-conversation') }}
    </div>

    <template v-else>
      <div class="px-3 py-2 border-bottom">
        <div class="d-flex justify-content-between align-items-center">
          <strong>{{ conversation.waPhone }}</strong>
          <small class="text-muted">{{ conversation.channelType }}</small>
        </div>
        <small class="text-muted">
          {{ $t('whatsapp.conversation.started') }}
          {{ conversation.createdAt | moment('LLL') }}
        </small>
      </div>

      <div ref="scroller" class="flex-grow-1 overflow-auto px-3 py-2 bg-light">
        <div v-if="hasOlder" class="text-center mb-2">
          <b-button
            size="sm"
            variant="outline-secondary"
            :disabled="loading"
            @click="$emit('load-older')"
          >
            {{ $t('whatsapp.load-older') }}
          </b-button>
        </div>
        <div v-if="loading && !messages.length" class="text-center py-4">
          <b-spinner small />
        </div>
        <message-bubble
          v-for="message in messages"
          :key="message.id"
          :message="message"
        />
      </div>

      <composer :key="conversation.id" :conversation="conversation" />
    </template>
  </div>
</template>

<script>
import Composer from './Composer.vue';
import MessageBubble from './MessageBubble.vue';

export default {
  name: 'MessageThread',
  components: { Composer, MessageBubble },
  props: {
    conversation: { type: Object, default: null },
    messages: { type: Array, required: true },
    hasOlder: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  watch: {
    'conversation.id'() {
      this.$nextTick(this.scrollToBottom);
    },
    messages(next, previous) {
      // A live message arriving appends one row; loading an older page prepends
      // many. Only the former should yank the view to the bottom — otherwise
      // "load older" scrolls away from what the reader just asked to see.
      const appended =
        next.length > previous.length && next[0]?.id === previous[0]?.id;
      if (appended || !previous.length) {
        this.$nextTick(this.scrollToBottom);
        return;
      }
      if (next.length > previous.length) {
        // Prepend: hold the reader's place by re-adding the height that was
        // inserted above them. Without this the viewport jumps to the top of
        // the newly loaded page.
        const el = this.$refs.scroller;
        if (!el) return;
        const before = el.scrollHeight - el.scrollTop;
        this.$nextTick(() => {
          el.scrollTop = el.scrollHeight - before;
        });
      }
    },
  },
  mounted() {
    this.$nextTick(this.scrollToBottom);
  },
  methods: {
    scrollToBottom() {
      const el = this.$refs.scroller;
      if (el) el.scrollTop = el.scrollHeight;
    },
  },
};
</script>
